<template>
  <v-alert
    :value="showLicenseAlert"
    :type="licenseAlertType"
    class="layout-license-alert"
    :class="showLicenseAlert ? 'visible' : ''"
  >
    <div>
      <b>Attention Required!</b> Your license is scheduled to expire on
      <span>{{ licenseExpirationDate }}</span
      >. Please contact your account executive to discuss renewal options.
    </div>
    <v-btn small class="sb-btn-outline-neutral" @click="hideAlert">
      Remind me later
    </v-btn>
  </v-alert>
</template>

<script>
import Cookies from 'js-cookie';

export default {
  name: 'LicenseAlert',
  data() {
    return {
      showLicenseAlert: false,
      licenseAlertType: 'warning',
      licenseExpirationDate: '',
      licenseJsonString: undefined,
    };
  },
  async created() {
    await this.getLicense();
    window.Cookies = Cookies;
    this.$root.$on('license-updated', this.handleLicenseUpdated);
  },
  methods: {
    handleLicenseUpdated(license) {
      Cookies.set('license-json', JSON.stringify([license]), { expires: 1 });
      if (Cookies.get('license-check')) return;
      this.checkLicense(license);
    },
    async getLicense() {
      // if the license has been dismissed then no need to check for it
      if (Cookies.get('license-check')) {
        return;
      }
      this.licenseJsonString = Cookies.get('license-json');
      // if we can't get the license then wait and try again
      if (!this.licenseJsonString) {
        setTimeout(() => {
          this.getLicense();
        }, 5000);
        return;
      } else {
        const [license] = JSON.parse(this.licenseJsonString);
        this.checkLicense(license);
      }
    },
    checkLicense({ activationDate, expirationDate } = {}) {
      const startDate = new Date(activationDate);
      const endDate = new Date(expirationDate);
      if (isNaN(startDate) || isNaN(endDate)) {
        return;
      }
      this.licenseExpirationDate = endDate.toLocaleDateString();

      const licenseDuration = this.getDayDiff(startDate, endDate);
      const remainingDays = this.getDayDiff(new Date(), endDate);
      const alertType = this.getAlertType(licenseDuration, remainingDays);
      this.showLicenseAlert = !!alertType;
      if (alertType) {
        this.licenseAlertType = alertType;
      }
    },
    hideAlert() {
      // remove the alert
      this.showLicenseAlert = false;
      // set the cookie
      Cookies.set('license-check', 1, { expires: 1 });
    },
    getDayDiff(startDate, endDate) {
      return Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24));
    },
    getAlertType(licenseDuration, remainingDays) {
      if (Number.isNaN(licenseDuration) || Number.isNaN(remainingDays)) {
        return;
      }
      const oneMonth = 30;
      const fourMonths = oneMonth * 4;
      const eightMonths = oneMonth * 8;

      if (licenseDuration < 365) {
        // no warning for licenses less than 1 year
        return;
      }
      const warningCutoff = licenseDuration > 365 ? eightMonths : fourMonths;
      const errorCutoff = licenseDuration > 365 ? fourMonths : oneMonth;
      if (remainingDays > warningCutoff) {
        return;
      }
      if (remainingDays < errorCutoff) {
        return 'error';
      } else {
        return 'warning';
      }
    },
  },
};
</script>

<style lang="scss">
.layout-license-alert {
  margin: 60px 0 -56px 60px;
  & > div {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
  }
  .v-btn {
    margin: 0;
  }
}
</style>
